import React from 'react';
import {faSort, faSortUp, faSortAsc, faSortDesc} from "@fortawesome/free-solid-svg-icons";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";


function Sort({target, handleSortChange, pageInfo}) {

    const pageHandler = ()=>{
        handleSortChange(target)
    }
    return (
        <div className="inline-block float-right mr-[5px]" style={{color:"rgb(179 179 179)"}} onClick={pageHandler}>
            { (target === pageInfo.sort) ?  pageInfo.desc ?
                (
                    <FontAwesomeIcon icon={faSortDesc} className={'text-[black]'}/>
                ):(
                    <FontAwesomeIcon icon={faSortAsc} className={'text-[black]'}/>
                )
                :(

                    <FontAwesomeIcon icon={faSort} className={''}/>
                )

            }

        </div>
    );
}

export default Sort;